import React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import c from 'classnames';
import './style.scss';

type Props = {
  title: string;
  body: string;
  nid: number;
  path: string;
  department: string;
  location?: string;
  employmentType: string;
  withBackground?: boolean;
};

const VacancyTeaser = (props: Props) => {
  const {
    title,
    body,
    nid,
    path,
    department,
    location,
    employmentType,
    withBackground,
  } = props;

  const classes = c('VacancyTeaser', 'icon-after', 'icon-arrow_forward', 'icon-variant-red-grey', {
    'VacancyTeaser--with-background': withBackground,
  });

  return (
    <div className={classes} data-cy={nid}>
      <CoreLink to={path} title={title} className="u-link-stretch">
        <h4 className="my-0">{title}</h4>
      </CoreLink>
      <div className="VacancyTeaser__department">{department}</div>
      <div className="VacancyTeaser__body">{body}</div>
      {location && <div className="VacancyTeaser__location icon-before icon-location_on icon-variant-red-grey">{location}</div>}
      <div className="VacancyTeaser__employmentType icon-before icon-schedule icon-variant-red-grey">{employmentType}</div>
    </div>
  );
};

export default VacancyTeaser;
